import Vue from 'vue';
import axios from 'axios';
import Cookies from 'js-cookie';
import store from '@/store';
import Events from '@/app/events.js'

// Remove errors for the interceptor
axios.interceptors.response.use(function (response) {

	if(response.hasOwnProperty('data') && response.data.hasOwnProperty('message')){

		let message = `Success, ${response.data.message}`;

		Vue.toasted.show(message, { 
			type: 'success',
			theme: "toasted-primary", 
			position: "top-right", 
			duration : 2500,
		});

	}


	return response;

}, function (error) {
	
	let message = "Unable to connect to API";

	if(error.response.status == 401){
		store.commit('setUserAuthState',false)
		Events.$emit('auth-verify',false)
	}

	if(error.response.hasOwnProperty('status')){
		message = `Error: ${error.response.status}`;
	}

	if(error.response.hasOwnProperty('data')){
		message = ( error.response.data.hasOwnProperty('message') ) ? `Warning, ${error.response.data.message}` : 'Warning, something went wrong.';
	}

	Vue.toasted.show(message, { 
		type: 'error',
		theme: "toasted-primary", 
		position: "top-right", 
		duration : 2500,
	});

	return Promise.reject(error);

});


export default axios;